import { ApiError } from '@/lib/api/client';
import { CandidateSchema, type Candidate } from '@/lib/api/discovery-sessions';

/** The API's own sentence for a refused write (it names the rule and what to do). */
export function errorText(e: unknown): string {
  if (e instanceof Error && e.message) return e.message;
  return 'That did not work. Try again.';
}

/**
 * The likely matches of a `person.possible_duplicate` refusal (rule 6): the
 * same-person question must be answered before anything is saved.
 */
export function duplicateCandidates(e: unknown): Candidate[] | null {
  if (!(e instanceof ApiError) || e.details?.['reason'] !== 'person.possible_duplicate') {
    return null;
  }
  const parsed = CandidateSchema.array().safeParse(e.details['candidates']);
  return parsed.success ? parsed.data : [];
}
